export default "__VITE_ASSET__CgHdrCwD__"